import { h } from "preact";
import FormattedDate from "../../../common/components/FormattedDate";
import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import { isMobileOnly } from "react-device-detect";
import { CALENDAR_VIEW } from "../../../calendar-common/constants";

const PeriodRow = connectWithTranslations("settings")(
    ({ settings, date, translate }) =>
        isMobileOnly ? (
            <tr>
                <td colspan="5" class="fxs_c_period fxs_c_period_fixed">
                    <FormattedDate date={date} format="LLLL_noTimeYear" />
                </td>
            </tr>
        ) : (
            <tr>
                <td colspan={settings.view == CALENDAR_VIEW.Configure_View_Basic ? "10" : "11"} class="fxs_c_period">
                    <FormattedDate date={date} format="LLLL_noTimeYear" />
                </td>
            </tr>
        )
);

export default PeriodRow;
